<template>
    <div class="row g-5 g-xl-8" v-for="(module, moduleIndex) in modules" :key="moduleIndex" :class="{'mt-6': moduleIndex !== 0 }">
        <div>
            <h3 class="text-dark">{{ module.name }}</h3>
            <el-divider class="mt-3 mb-4"></el-divider>
            <ModuleList :list="module.items"/>
        </div>
    </div>

</template>

<script>
import ModuleList from "@/components/card-list/ModuleList.vue";

export default {
    name: "index",
    components: {ModuleList},
    data() {
        return {
            redirectUrlPattern: '/module/%s',
            customRedirect: {
                VEHICLE_WORK_ORDER: "/module/vehicle-work-order",
            },
            customAction: {
                NOTE: 'panel:noteApp',
                AGENDA: 'panel:agendaPanel',
                WEATHER: 'panel:weatherPanel',
                MUSIC: 'panel:musicPanel',
            },
            customSvgIcon: {
                DEFAULT_ICON: "/media/icons/duotune/abstract/abs027.svg",
                VEHICLE_WORK_ORDER: "/media/icons/duotune/art/art002.svg",
                NETGSM: "/media/icons/duotune/communication/com003.svg",
            }
        }
    },
    computed: {
        modules() {
            const list = this.$store.state.company.module.table.data || []

            const grouped = list.reduce((acc, item) => {
                if (!(item?.supported?.gui === false && item?.supported?.settings === false && item?.supported?.credentials === false)) {
                    const key = item.kind.code

                    if (!acc[key]) {
                        acc[key] = {
                            slug: this.getRedirectUrl(item),
                            code: item.kind.code,
                            name: item.kind.name,
                            items: []
                        }
                    }

                    acc[key].items.push({
                        ...item,
                        description: this.$t("pages.module." + item.code + ".description"),
                        svgIcon: this.getSvgIcon(item),
                        slug: this.getRedirectUrl(item),
                        action: this.customAction[item.code] || null
                    })
                }

                return acc
            }, {})

            return Object.values(grouped)
        },
    },
    created() {
        
    },
    mounted() {
        this.setCurrentPageBreadcrumbs(this.$t("menu.modules"), [this.$t("menu.moduleManagement")]);

        this.$store.dispatch('company/module/get', {
            page: {
                pageSize: 9999
            }
        });
    },
    methods: {
        getRedirectUrl(item) {
            if (this.customRedirect[item.code]) {
                return this.customRedirect[item.code];
            }

            return this.sprintf(this.redirectUrlPattern, [item.code.toLowerCase().replaceAll('_', '-')]);
        },
        getSvgIcon(item) {
            if (this.customSvgIcon[item.code]) {
                return this.customSvgIcon[item.code];
            }

            return this.customSvgIcon['DEFAULT_ICON'];
        },
    }
}
</script>

<style>
.module-card .card-header {
    min-height: 65px;
}
</style>